// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__b9VZQ","errors":"Errors_errors__RrWoH"};